import { type RouteRecordRaw } from '@gat-ship/lib/router'
import { createAgencyRoutes } from './src/agency/routes/agency-routes'
import { createCompaniesRoutes } from './src/companies/routes/companies-routes'
import { createAccessControlRoutes } from './src/access-control/routes/access-control-routes'
import { createTenantUsersAdministrationRoutes } from './src/tenant-users/routes/tenant-users-routes'
import { createMonetaryRoutes } from './src/monetary/routes/monetary-routes'
import { createSettingsRoutes } from './src/settings/routes/settings-routes'

export function createAdministrationRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      component: () => import('./src/layouts/administration-layout.vue'),
      children: [
        {
          path: '',
          redirect: () => '/agency'
        },
        ...createAgencyRoutes('agency'),
        ...createCompaniesRoutes('company'),
        ...createTenantUsersAdministrationRoutes('tenant-users'),
        ...createAccessControlRoutes('access-control'),
        ...createMonetaryRoutes('monetary'),
        ...createSettingsRoutes('settings')
      ]
    }
  ]
}
